import { takeLatest, all, select, put } from 'redux-saga/effects';
import { logger } from 'src/error';
import {
  getHotelPlaceId,
  getHotelCoordinates,
} from 'src/routes/Hotel/store/hotel';
import { INIT_APP } from '../../../../store/view/constants';
import { getMapDataAction, setMapDataAction } from '../actions/map';
import { GET_MAP_DATA } from '../constants/map';
import { api } from '../../../../api';

function* handleInitApp() {
  const coordinates = yield select(getHotelCoordinates);

  if (!coordinates) {
    yield put(getMapDataAction());
  }
}

function* handleGetMapData() {
  try {
    const placeId = yield select(getHotelPlaceId);
    const response = yield api.getReferencesHotelMapData({ place_id: placeId });

    if (response) {
      yield put(setMapDataAction(response));
    } else {
      throw new Error('Нет ответа от сервера, метод hotel_map_data');
    }
  } catch (error) {
    logger(error, 'Map: Не удалось получить данные карты');
  }
}

export default function* mapWatcher() {
  yield all([
    takeLatest(INIT_APP, handleInitApp),
    takeLatest(GET_MAP_DATA, handleGetMapData),
  ]);
}
